import { atom } from 'jotai';
import { domain } from 'modules/data';

export const schedulerIncludeStartYearState = atom<number>(new Date().getFullYear());

export const schedulerIncludeEndYearState = atom<number>(new Date().getFullYear());

export const schedulerExcludedYearsState = atom<(string | number)[]>([]);

export const schedulerRadioCheckedState = atom<domain.ScheduleYearType>(domain.ScheduleYearType.EveryYear);
